// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FlexInput_flexInput__\\+pEts {
    display: block;
}

.FlexInput_flexInputContainer__KC7HN {
    border: 1.5px solid var(--color-lightui-surface-4);
    border-radius: 4px;
    width: fit-content;
    display: flex;
    background-color: white;
}

.FlexInput_flexInputContainer__KC7HN.FlexInput_disabled__yV825 {
    background-color: var(--color-lightui-surface-2);
}

.FlexInput_input__FhFbe.FlexInput_disabled__yV825 {
    background-color: var(--color-lightui-surface-2);
}

.FlexInput_flexInputContainerFill__RpFBg {
    width: 100%;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_input__FhFbe {
    border: none;
    padding:  1px 8px 1px 8px;
    overflow: hidden;
}

.FlexInput_inputError__ooDH0 {
    outline: 2.5px solid var(--color-red-dark-1);
    outline-offset: -1.5px;
}

.FlexInput_flexInputContainer__KC7HN:focus-within,
.FlexInput_flexInputContainer__KC7HN:focus-within:hover {
    outline: 2.5px solid var(--color-primary);
    outline-offset: -1.5px;
}

.FlexInput_flexInputContainer__KC7HN:not(.FlexInput_disabled__yV825):hover {
    border: 1.5px solid var(--color-lightui-accent-2);
}

.FlexInput_disabled__yV825 {
    background-color: var(--color-lightui-surface-2);
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_icon__yER2C {
    display: flex;
    padding-right: 8px;
    padding-bottom: 2px;
    align-items: center;
    pointer-events: none;
    width: unset;
    height: unset;
    border: none;
    background: transparent;
    color: var(--color-secondary);
    font-size: 16px;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_appendedLabel__3M0dm {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    margin-left: -1.5px;
    color: var(--color-secondary);
    box-shadow: none;
    border-left: 1.5px solid var(--color-lightui-surface-4);
    border-radius: 0px 4px 4px 0px;
    padding-left: 8px;
    padding-right: 8px;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_prependedLabel__hc8Pb {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    margin-left: 1.5px;
    color: var(--color-secondary);
    box-shadow: none;
    border-right: 1.5px solid var(--color-lightui-surface-4);
    padding-left: 8px;
    padding-right: 8px;
}

.FlexInput_flexInputContainer__KC7HN input[type=password]::-webkit-contacts-auto-fill-button,
.FlexInput_flexInputContainer__KC7HN input[type=password]::-webkit-credentials-auto-fill-button {
   visibility: hidden;
   display: none !important;
   pointer-events: none;
   height: 0;
   width: 0;
   margin: 0;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_textAlignRight__COsJ9 {
    text-align: right;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_iconToggle__l3AOB,
.FlexInput_flexInputContainer__KC7HN .FlexInput_iconToggle__l3AOB {
    display: flex;
    padding-right: 8px;
    padding-bottom: 2px;
    align-items: center;
    border: none;
    background: transparent;
    color: var(--color-secondary);
    width: unset;
    height: unset;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_iconToggle__l3AOB svg {
    height: 16px;
    width: 16px;
    padding-right: 0px;
}


.FlexInput_flexInputContainer__KC7HN .FlexInput_iconToggle__l3AOB [class*="icon-"] {
    height: 16px;
    width: 16px;
    padding-right: 0px;
    font-size: 16px;
    line-height: 16px;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_inputXXSmall__7FrWd {
    width: 48px;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_inputXSmall__Q9VAK {
    width: 60px;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_inputSmall__qdRF6 {
    width: 90px;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_inputSmallMedium__ypckD {
    width: 120px;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_inputMedium__mOmei {
    width: 150px;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_inputLarge__VOhwt {
    width: 210px;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_inputXLarge__mJ2rU {
    width: 270px;
}

.FlexInput_flexInputContainer__KC7HN .FlexInput_inputFill__sbOI9 {
    width: 100%;
}

/* --- Story Styles --- */

.FlexInput_formButton__iNw8T {
    color: white;
    border-radius: 4px;
    padding: 4px 8px 4px 8px;
    background: var(--color-primary);
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/FlexInput/FlexInput.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,sBAAsB;AAC1B;;AAEA;;IAEI,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uHAAuH;IACvH,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,uDAAuD;IACvD,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uHAAuH;IACvH,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,wDAAwD;IACxD,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;GAEG,kBAAkB;GAClB,wBAAwB;GACxB,oBAAoB;GACpB,SAAS;GACT,QAAQ;GACR,SAAS;AACZ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA,yBAAyB;;AAEzB;IACI,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,eAAe;AACnB","sourcesContent":[".flexInput {\n    display: block;\n}\n\n.flexInputContainer {\n    border: 1.5px solid var(--color-lightui-surface-4);\n    border-radius: 4px;\n    width: fit-content;\n    display: flex;\n    background-color: white;\n}\n\n.flexInputContainer.disabled {\n    background-color: var(--color-lightui-surface-2);\n}\n\n.input.disabled {\n    background-color: var(--color-lightui-surface-2);\n}\n\n.flexInputContainerFill {\n    width: 100%;\n}\n\n.flexInputContainer .input {\n    border: none;\n    padding:  1px 8px 1px 8px;\n    overflow: hidden;\n}\n\n.inputError {\n    outline: 2.5px solid var(--color-red-dark-1);\n    outline-offset: -1.5px;\n}\n\n.flexInputContainer:focus-within,\n.flexInputContainer:focus-within:hover {\n    outline: 2.5px solid var(--color-primary);\n    outline-offset: -1.5px;\n}\n\n.flexInputContainer:not(.disabled):hover {\n    border: 1.5px solid var(--color-lightui-accent-2);\n}\n\n.disabled {\n    background-color: var(--color-lightui-surface-2);\n}\n\n.flexInputContainer .icon {\n    display: flex;\n    padding-right: 8px;\n    padding-bottom: 2px;\n    align-items: center;\n    pointer-events: none;\n    width: unset;\n    height: unset;\n    border: none;\n    background: transparent;\n    color: var(--color-secondary);\n    font-size: 16px;\n}\n\n.flexInputContainer .appendedLabel {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 21px;\n    margin-left: -1.5px;\n    color: var(--color-secondary);\n    box-shadow: none;\n    border-left: 1.5px solid var(--color-lightui-surface-4);\n    border-radius: 0px 4px 4px 0px;\n    padding-left: 8px;\n    padding-right: 8px;\n}\n\n.flexInputContainer .prependedLabel {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 21px;\n    margin-left: 1.5px;\n    color: var(--color-secondary);\n    box-shadow: none;\n    border-right: 1.5px solid var(--color-lightui-surface-4);\n    padding-left: 8px;\n    padding-right: 8px;\n}\n\n.flexInputContainer input[type=password]::-webkit-contacts-auto-fill-button,\n.flexInputContainer input[type=password]::-webkit-credentials-auto-fill-button {\n   visibility: hidden;\n   display: none !important;\n   pointer-events: none;\n   height: 0;\n   width: 0;\n   margin: 0;\n}\n\n.flexInputContainer .textAlignRight {\n    text-align: right;\n}\n\n.flexInputContainer .iconToggle,\n.flexInputContainer .iconToggle {\n    display: flex;\n    padding-right: 8px;\n    padding-bottom: 2px;\n    align-items: center;\n    border: none;\n    background: transparent;\n    color: var(--color-secondary);\n    width: unset;\n    height: unset;\n}\n\n.flexInputContainer .iconToggle svg {\n    height: 16px;\n    width: 16px;\n    padding-right: 0px;\n}\n\n\n.flexInputContainer .iconToggle [class*=\"icon-\"] {\n    height: 16px;\n    width: 16px;\n    padding-right: 0px;\n    font-size: 16px;\n    line-height: 16px;\n}\n\n.flexInputContainer .inputXXSmall {\n    width: 48px;\n}\n\n.flexInputContainer .inputXSmall {\n    width: 60px;\n}\n\n.flexInputContainer .inputSmall {\n    width: 90px;\n}\n\n.flexInputContainer .inputSmallMedium {\n    width: 120px;\n}\n\n.flexInputContainer .inputMedium {\n    width: 150px;\n}\n\n.flexInputContainer .inputLarge {\n    width: 210px;\n}\n\n.flexInputContainer .inputXLarge {\n    width: 270px;\n}\n\n.flexInputContainer .inputFill {\n    width: 100%;\n}\n\n/* --- Story Styles --- */\n\n.formButton {\n    color: white;\n    border-radius: 4px;\n    padding: 4px 8px 4px 8px;\n    background: var(--color-primary);\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexInput": `FlexInput_flexInput__+pEts`,
	"flexInputContainer": `FlexInput_flexInputContainer__KC7HN`,
	"disabled": `FlexInput_disabled__yV825`,
	"input": `FlexInput_input__FhFbe`,
	"flexInputContainerFill": `FlexInput_flexInputContainerFill__RpFBg`,
	"inputError": `FlexInput_inputError__ooDH0`,
	"icon": `FlexInput_icon__yER2C`,
	"appendedLabel": `FlexInput_appendedLabel__3M0dm`,
	"prependedLabel": `FlexInput_prependedLabel__hc8Pb`,
	"textAlignRight": `FlexInput_textAlignRight__COsJ9`,
	"iconToggle": `FlexInput_iconToggle__l3AOB`,
	"inputXXSmall": `FlexInput_inputXXSmall__7FrWd`,
	"inputXSmall": `FlexInput_inputXSmall__Q9VAK`,
	"inputSmall": `FlexInput_inputSmall__qdRF6`,
	"inputSmallMedium": `FlexInput_inputSmallMedium__ypckD`,
	"inputMedium": `FlexInput_inputMedium__mOmei`,
	"inputLarge": `FlexInput_inputLarge__VOhwt`,
	"inputXLarge": `FlexInput_inputXLarge__mJ2rU`,
	"inputFill": `FlexInput_inputFill__sbOI9`,
	"formButton": `FlexInput_formButton__iNw8T`
};
export default ___CSS_LOADER_EXPORT___;
